import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import cih_brain from "../../assets/landingPageImg/cih_brain.png";
import cust_360 from "../../assets/landingPageImg/customer360.png";
import cust_first from "../../assets/landingPageImg/cust_first.png";
import insight from "../../assets/landingPageImg/insight.png";
import veh_360 from "../../assets/landingPageImg/vehicle360.png";
import dealer360 from "../../assets/landingPageImg/dealer360.png";
import { FaInstalod } from "react-icons/fa";
import HexagonCard from "./HexagonCard";
import CustomModal from "./CustomModel";
import BackgroundVideo from "./BackgroundVideo";
import Landingpageheader from "../../components/Header/Landingpageheader";
import config from "../../config/config";

const Newlanding = () => {
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [activeNavCard, setActiveNavCard] = useState("");
  const navigate = useNavigate();

  return (
    <div>

      <div className="  relative  flex flex-col  min-h-screen w-full">
        <Landingpageheader />

        <BackgroundVideo />
        <div className="gap-10 flex flex-col">

          <div className="z-10 text-center ">
            <h1 className="text-2xl font-bold text-gray-500 drop-shadow-md">
              Welcome To
            </h1>
            <h2 className="text-3xl font-bold text-gray-500 drop-shadow-md">
              Customer Intelligence Hub
            </h2>
          </div>

          <div className="flex flex-col  md:mt-12 z-10 ">
            <div className="flex flex-col sm:flex-col md:flex-row lg:flex-row justify-center gap-6 md:gap-0 ">
              <div className="md:translate-y-12 justify-center text-center">
                coming soon

                <HexagonCard
                  title="CIH Brain"
                  icon={cih_brain}

                />  </div>
              <div className="md:-translate-y-14">
                <HexagonCard
                  title="Vehicle 360"
                  icon={veh_360}
                  onClick={() => (window.location.href = config.vehicle360Url)}
                />
              </div>

              <div className="justify-center text-center md:translate-y-12">
                coming soon
                <HexagonCard
                  title=" Customer First"
                  icon={cust_first}
                // onClick={() =>
                // (window.location.href =
                //   "https://vehicle360cv.infoportal.cv.tatamotors/login/index")
                // }
                />          </div>

              <div className="md:-translate-y-14">

                <HexagonCard
                  title="Customer 360"
                  icon={cust_360}
                  // onClick={() => navigate("/login")}
                  onClick={() => navigate("/home")}

                /></div>

              <div className="md:translate-y-12 justify-center text-center">
                coming soon


                <HexagonCard
                  title=" Customer Insights"
                  icon={insight}
                // onClick={() =>
                //   (window.location.href = "https://dealer360.cv.tatamotors/")
                // }
                /></div>
              <div className="md:-translate-y-14">

                <HexagonCard
                  title="Dealer 360"
                  icon={dealer360}
                  onClick={() => (window.location.href = config.dealer360Url)}
                /></div>

            </div>
          </div>
        </div>

        {/* <CustomModal
        title={"Select Vehicle Type"}
        isVisible={showVehicleModal}
        onClose={() => {
          setShowVehicleModal(false);
        }}
      >
        <div className="flex flex-col justify-around p-4 gap-2">
          <button
            // onClick={() => handleVehicleChoice("EV")}
            style={{
              background: "linear-gradient(90deg, #667EEA, #764BA2)",
            }}
            className="text-white font-semibold px-4 py-2 rounded-full shadow-md transition hover:opacity-90"
          >
            EV Vehicle 360
          </button>
 
          <button
            // onClick={() => handleVehicleChoice("PV")}
            style={{
              background: "linear-gradient(90deg, #667EEA, #764BA2)",
            }}
            className="text-white font-semibold px-4 py-2 rounded-full shadow-md transition hover:opacity-90"
          >
            PV Vehicle 360
          </button>
        </div>
      </CustomModal> */}
      </div>    </div>

  );
};

export default Newlanding;